import {defaults, DragPan} from "ol/interaction";
import {Vector as VectorLayer} from "ol/layer";
import {Vector as VectorSource} from "ol/source";

export const createDefaultInteractions = (isTouch) => {
    return defaults({
        dragPan: !isTouch,
        mouseWheelZoom: true,
        altShiftDragRotate: false,
        shiftDragZoom: false,
    })
};

export const updateInteractionsForTouch = (interactions) => {
    interactions.extend([
      new DragPan({
            condition: function () {
                return this.getPointerCount() === 2;
            }
        })
    ])
};

export const createVectorLayer = ({features = [], ...options}) => {
    return new VectorLayer({
        source: new VectorSource({
            features
        }),
        ...options
    })
};